<script setup lang="ts">
defineOptions({
  name: 'ImpressumPage'
})
</script>

<template>
  <div>
    <Head>
      <Title>Impressum</Title>
      <Meta
        name="description"
        content="Impressum von johnsenpartner. architekten – Angaben gemäß § 5 TMG, Kontakt und berufsrechtliche Informationen."
      />
    </Head>
    <Impressum />
  </div>
</template>
